<template>
  <div class="pb-5" data-wizard-type="step-content">
    <div class="row">
      <div class="col-xl-8">
        <h4 class="mb-10 font-weight-bold text-dark">
          {{
            !!video.videoPath
              ? "Saisissez les informations à modifier en Français"
              : "Saisissez les informations à créer en Français"
          }}
        </h4>
        <div class="form-group">
          <v-text-field
            :rules="titleErrors"
            type="text"
            v-model="video.title"
            label="Titre de la vidéo *"
          />
        </div>
        <div class="form-group">
          <v-textarea
            :rules="descErrors"
            v-model="video.description"
            label="Description de la vidéo *"
            value="25"
          />
        </div>
        <!-- Sélection du thème  -->
        <div class="row">
          <div class="col-xl-9"><h5 class="mb-7">Thème *</h5></div>
          <div class="col-xl-3 text-end">
            <a
              class="btn btn-light-danger"
              color="primary"
              @click.stop="dialog = true"
            >
              {{
                !!video.theme && video.theme.length > 0
                  ? "Modifier le thème"
                  : "Ajouter un thème"
              }}
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <div class="form-group">
              <v-simple-table class="elevation-2">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Thème à laquelle la vidéo appartient
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in video.theme" :key="item.id">
                      <td>{{ item.title }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p class="mt-3 subtitle-1 font-weight-light">
                Vous n'aurez pas à choisir à nouveau le thème pour la partie
                "Anglais"
              </p>
            </div>
          </div>
        </div>
        <!-- Sélection du partenaire  -->
        <div class="row">
          <div class="col-xl-6"><h5 class="">Partenaire</h5></div>
        </div>
        <div class="row">
          <div class="col-12">
            <v-autocomplete
                v-model="video.partner"
                label="Sélection du partenaire"
                :items="partners"
                item-key="id"
                item-text="name"
                return-object
                small-chips
                solo
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    <v-avatar left>
                      <v-img :src="getPartnerLogo(data.item)"></v-img>
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="(typeof data.item !== 'object')" >
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-avatar>
                      <v-img :src="getPartnerLogo(data.item)"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
          </div>
        </div>
        <!-- Vues historiques -->
        <div class="row">
          <div class="col-xl-6"><h5 class="">Nombre de vues historique</h5></div>
        </div>
        <div class="form-group">
          <v-text-field
            v-model="video.views"
            hide-details
            single-line
            type="number"
            label="Nombre de vues historique"
          />
        </div>
         
        <!-- Tags / Mots-clés -->
        <div class="form-text"><h5>Tags / Mots-clés de la vidéo *</h5></div>
        <div class="row">
          <div class="col-xl-6">
            <div class="form-group">
              <label><i class="la la-eye"></i> Visibles</label>

              <v-combobox
                v-model="video.keywords.visibleFR"
                :items="keywords.visibleFR"
                label="Tags visibles"
                multiple
                chips
                item-text="name"
                return-object
                clearable
                deletable-chips
                hide-selected
                :rules="[required]"
                ><template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Mot-clé inexistant. Appuyer sur Entrer pour
                      <strong>le créer</strong>
                    </v-list-item-title>
                  </v-list-item>
                </template></v-combobox
              >
            </div>
          </div>
          <div class="col-xl-6">
            <div class="form-group">
              <label><i class="la la-eye-slash"></i> Invisibles</label>

              <v-combobox
                v-model="video.keywords.invisibleFR"
                :items="keywords.invisibleFR"
                label="Tags invisibles"
                multiple
                chips
                item-text="name"
                return-object
                clearable
                deletable-chips
                hide-selected
                :rules="[required]"
                ><template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Mot-clé inexistant. Appuyer sur Entrer pour
                      <strong>le créer</strong>
                    </v-list-item-title>
                  </v-list-item>
                </template></v-combobox
              >
            </div>
          </div>
        </div>


        <!-- Modal pour choisir le thème  -->
        <v-dialog v-model="dialog" max-width="490">
          <v-card class="mx-auto" max-width="500">
            <v-sheet class="pa-4 primary lighten-2">
              <v-text-field
                v-model="search"
                label="Rechercher le nom d'un thème..."
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
              <v-checkbox
                v-model="caseSensitive"
                dark
                hide-details
                label="Activer la sensibilité à la casse"
              ></v-checkbox>
            </v-sheet>
            <v-card-text>
              <v-treeview
                :active="video.theme"
                activatable
                :items="themes"
                item-key="id"
                item-text="title"
                :search="search"
                :filter="filter"
                :open.sync="open"
                open-on-click
                @update:active="(selected) => themeSelected(selected)"
                return-object
              >
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file">
                    {{ open ? "mdi-folder-open" : "mdi-folder" }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
              </v-treeview>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  v-if="!!video.theme && video.theme.length > 0"
                  depressed
                  color="warning"
                  @click="removeActiveTheme"
                >
                  Effacer la sélection
                </v-btn>

                <v-btn depressed color="primary" @click="dialog = false">
                  Ajouter le thème
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- bouton droits utilisateurs & utilisateurs pour le mode add -->
        <div class="d-flex justify-content-around col-8">
          <!-- button dialog Droits utilisateurs-->
          <div>
            <v-dialog v-model="dialog1" width="600px" max-height="400px">
              <template v-slot:activator="{ on }">
                <!-- <v-btn color="primary" dark v-on="on">({{userRights.length}}) Droits utilisateurs</v-btn> -->
                <v-btn color="primary" dark v-on="on">Droits utilisateurs</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline pl-2">Nom des droits utilisateurs</span>
                </v-card-title>
                <v-card-text>
                  <!-- Display Client -->
                  <div class="py-5">
                    <v-simple-table fixed-header dense>
                      <tr class="py-0" v-for="userRight in userRights" :key="userRight.id" >
                        <td style="font-size:13px">{{ userRight.name }}</td>
                      </tr>
                    </v-simple-table>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog1 = false">Fermer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <!-- button dialog Utilisateurs-->
          <div>
            <v-dialog v-model="dialog2" width="600px" max-height="400px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">Utilisateurs</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <div class="headline pl-2">Utilisateurs (Prénom Nom Client)</div>
                </v-card-title>
                <v-card-text>
                  <!-- Display utilisateur -->
                  <div class="py-5">
                    <v-simple-table fixed-header dense>

                        <div class="py-0" v-for="user in users" :key="user.id">
                          <span style="font-size:13px"> {{ user.firstname }} {{ user.lastname }} </span>
                          <span v-if="user.client" class="py-0">
                            <b><span style="font-size: 13px"> {{ user.client.name }}</span></b>
                          </span>
                        </div>

                    </v-simple-table>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog2 = false">Fermer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

        </div>
      </div>

      <div class="col-xl-4">
        <video v-if="video.videoPath" controls width="400">
          <source :src="apiUrl + video.videoPath" type="video/mp4" />

          Sorry, your browser doesn't support embedded videos.
        </video>
         <h5 class="mt-4">Si vous souhaitez que cette vidéo soit liée à un client spécifique, veuillez le sélectionner :</h5>
        <v-select
          :items="clients"
          label="Nos clients"
          item-key="id"
          item-text="name"
          clearable
          v-model="video.client"
          return-object
        ></v-select>

        <v-switch
          v-model="video.isVisible"
          :label="`La vidéo est : ${ !!video.isVisible && video.isVisible == true ? 'En ligne': 'Hors ligne'}`"
          color="error"
          hide-details
        ></v-switch>
        <v-btn
          v-if="video.videoPath"
          class="ma-2 float-right"
          color="primary"
          @click.stop="$emit('openFileDropEdit')"
        >
          Modifier la vidéo
        </v-btn>

      </div>
    </div>
  </div>

  <!--end: Wizard Step 2-->
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
video {
  width: 100%;
  height: auto;
}
</style>

<script>
import Api from "@/core/services/api.service";
import userParentThemes from "@/core/utils/userParentThemes";
import { getPartnerLogoUrl } from '@/core/utils/partner';
import { mapGetters } from "vuex";

export default {
  name: "formVideoStep2",
  //On retrouve ici le custom v-mode:formData que je renomme en video pour plus de lisibilité
  model: {
    prop: "video",
    event: "input",
  },
  props: {
    video: Object,
    mode: String,
  },
  data: () => ({
    titleErrors: [
      (v) => !!v || "Le titre de la vidéo est obligatoire.",
      (v) => v.length >= 2 || "Le titre doit être supérieur à 2 caractères",
    ],
    descErrors: [
      (v) => !!v || "La description de la vidéo est obligatoire.",
      (v) =>
        v.length >= 2 || "La description doit être supérieure à 2 caractères",
    ],
    keywords: {
      visibleFR: [],
      invisibleFR: [],
    },
    themes: [],
    clients: [],
    partners: [],
    courses: [],
    userRights: [],
    users: [],
    open: [1, 2],
    search: null,
    caseSensitive: false,
    dialog: false,
    dialog1: false,
    dialog2: false,
    isLoading: false,
  }),

  computed: {
     ...mapGetters(["layoutConfig"]),
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },

  //Les fonctions de Mounted sont appelées au lancement de la page automatiquement
  mounted() {
    // Get all keywords with Symfony Api (api.service.js)
    this.getKeywords();
    this.isLoading=true;
    // Récupération des entités 
    Api.get("themes").then(themes => (this.themes = userParentThemes(themes.data["hydra:member"])));
    Api.get("partners").then(partners => {this.partners = partners.data["hydra:member"]});
    Api.get("clients").then((clients) => {
      this.clients = clients.data["hydra:member"];
    });
    
    if(typeof this.video.theme[0] !== "undefined"){
      Api.query("user_rights",{ params: { themes: this.video.theme[0]['@id'] } })
      .then(userRights => {
          this.userRights = userRights.data["hydra:member"]; 
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
        // recuperer droit utilisateur + user qu'il faut mettre dans un tableau en affichage
    }
  },

  //les fonctions de Methods ne sont pas appelées au chargement de la page, il faut les appeler.
  methods: {
    getPartnerLogo: function(partner) {
      return getPartnerLogoUrl(partner, process.env.BASE_URL + this.layoutConfig("self.nologo"));
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "Vous devez choisir ou créer un mot-clé";
      }
      return !!value || "Vous devez choisir ou créer un mot-clé";
    },
    getKeywords() {
      Api.get("keywords").then((keywords) => {
        keywords.data["hydra:member"].forEach((keyword) => {
          if (keyword.isVisible == true) {
            if (keyword.lang === "FR") {
              // Je 'range' tout les tags dans un tableau pour savoir s'ils sont visibles ou non
              this.keywords.visibleFR.push(keyword);
            }
          } else {
            if (keyword.lang == "FR") {
              this.keywords.invisibleFR.push(keyword);
            }
          }
        });
      });
    },
    removeActiveTheme() {
      this.video.theme = [];
    },
    themeSelected(selected){
      this.video.theme = selected;
      Api.query("user_rights",{ params: { themes: this.video.theme[0]['@id'] } })
      .then(userRights => {
          this.userRights = userRights.data["hydra:member"]; 
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    refreshUsers() {
      if (this.video) {
        Api.query("user_rights", { params: { themes: this.video.theme[0]['@id'] } })
        .then(response => {
          const userRights = response.data["hydra:member"];
          this.userRights = userRights;
          //if (typeof this.video.client === 'undefined' || !this.video.client) {
          this.users = [...new Set(userRights.map(ur => ur.users).flat())];
          //}
          if(this.video.client){
            this.users = this.users.filter((u)=>u.client['@id'] === this.video.client['@id'])
          }
        })
        .catch(err => console.log(err))
        .finally(() => this.isLoading = false);
    }
    }
  },
};
</script>
